// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7600eba4","455":"9b95265b","977":"634a862b"}[chunkId] + ".chunk.js";
};